import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { Vertical } from '@sorare/core/src/atoms/layout/flex';
import { BodyS } from '@sorare/core/src/atoms/typography';
import { Bold } from '@sorare/core/src/atoms/typography/Bold';
import { tabletAndAbove } from '@sorare/core/src/style/mediaQuery';

const Root = styled(Vertical)`
  max-width: 290px;
  @media ${tabletAndAbove} {
    max-width: none;
  }
`;
const List = styled.ul`
  padding-left: var(--double-unit);
  margin: 0;
  > li {
    list-style: disc;
  }
`;

export const BreakdownHelper = () => {
  return (
    <Root>
      <BodyS bold color="var(--c-nd-600)">
        <FormattedMessage
          id="playerDetails.performance.breakdownHelper.title"
          defaultMessage="Player Score = Decisive Score + All-Around Score"
        />
      </BodyS>
      <BodyS color="var(--c-nd-600)">
        <List>
          <li>
            <FormattedMessage
              id="playerDetails.performance.breakdownHelper.description.1"
              defaultMessage="<b>Decisive Score (DS)</b> is the sum of the statistics that are directly related to the player’s ability to score points in a match"
              values={{
                b: Bold,
              }}
            />
          </li>
          <li>
            <FormattedMessage
              id="playerDetails.performance.breakdownHelper.description.2"
              defaultMessage="<b>All-Around Score (AA</b> totals the statistics during a match that are less obvious to follow but are valuable for evaluating a player’s overall performance and his impact on a match"
              values={{
                b: Bold,
              }}
            />
          </li>
        </List>
      </BodyS>
    </Root>
  );
};
